import React, { Component } from 'react';
import { Textbox, Textarea } from 'react-inputs-validation';
import 'react-inputs-validation/lib/react-inputs-validation.min.css';
import Parser from 'html-react-parser';
import { NavLink } from "react-router-dom";
import Select2 from 'react-select2-wrapper';
import $ from 'jquery';
import UnAuthorised from "./UnAuthorised";
import { Alert, DateRangePicker } from 'rsuite';
import 'react-select2-wrapper/css/select2.css';
import {
  URL_RCPRIMEREVERSE,
  createAndDownloadPdfForRcPrime,
  API_DOC_BASE_URL,
  rc_prime_pdf_Authorization_Token,
  rc_prime_pdf_user_id,
  rc_prime_pdf_rto_user_id,
  unlink_file,
  LOGIN_TYPE_ADMIN,
  LOGIN_TYPE_USER,
  CLIENT_EDIT_VIEW,
  SERVICE21_TEXT
} from './helper/Constants';

import Apihelpers from './helper/ApiHelper';
import FileDownload from 'js-file-download';
import { reactLocalStorage } from "reactjs-localstorage";
import Header from "./include/Header";


class rcprimereversepdf extends Component {
  state = {
    Chassis_Number: "",
    rc_details: [],
    MsgBoxText: "",
    OnlyGetTheseDetailsOfApi: [],
    is_data_found: false,
    data_not_found: '',
    bbuser_have_plan: false,
    rc_prime_pdf_user_id: '',
    rc_prime_pdf_Authorization_Token: '',
    rc_prime_pdf_rto_user_id: '',
    urlForBackButton:'',
  };
  constructor(props) {
    super(props);
  }
  async componentDidMount() {
    if (reactLocalStorage.get("login_type") === LOGIN_TYPE_USER) {
      this.setState({urlForBackButton:`${"/admin/client-edit-view/"+reactLocalStorage.get("login_user_id")}`});
      this.Find_User_Have_Rc_Prime_Reverse_Pdf_Plan();
    }
    //when admin login then for get price prime data using testing Qa data 
    if (reactLocalStorage.get("login_type") === LOGIN_TYPE_ADMIN) {
      const adminToken = 'Bearer '+ reactLocalStorage.get("internalToken");
      this.setState({
        rc_prime_pdf_user_id: rc_prime_pdf_user_id,
        rc_prime_pdf_Authorization_Token: adminToken,//rc_prime_pdf_Authorization_Token,
        rc_prime_pdf_rto_user_id: rc_prime_pdf_rto_user_id,
        urlForBackButton:"/admin/client-list",
      });
    }
  }
  get_reverse_prime_details = (event) => {
    $('.loader').css("display", "block");
    if (this.state.Chassis_Number.length > 0 ) {
      const data = {
        rto_user_id: this.state.rc_prime_pdf_rto_user_id,
        user_id: this.state.rc_prime_pdf_user_id,
        chassisNumber: this.state.Chassis_Number,
        authorization_Token: this.state.rc_prime_pdf_Authorization_Token
      };
      this.setState({
        OnlyGetTheseDetailsOfApi: [
          "RC Blacklist Status",
          "Car Body Type",
          "Chassis Number",
          "Car Color",
          "Engine Capacity",
          "Engine Number",
          "Owner Fathers Name",
          "Financer",
          "Fitness upto",
          "Car Fuel Type",
          "Gross Vehicle Weight",
          "Insurer",
          "Policy Number",
          "Insurance upto",
          "Brand",
          "Model",
          "Manufacturing Year",
          "Cylinder Numbers",
          "Car NOC",
          "NOC from",
          "NOC Status",
          "NOC to",
          "Fuel Norms",
          "NP Issued by",
          "NP No",
          "NP upto",
          "Owner Name",
          "Owner Count",
          "Owner Permanent Address",
          "Permit Issue Date",
          "Permit Number",
          "Permit Type",
          "Permit Valid from",
          "Permit Valid upto",
          "Owner Present Address",
          "PUCC Number",
          "PUCC upto",
          "Registration RTO",
          "Registration Date",
          //"RC Number",
          "Seating Capacity",
          "Sleeper Capacity",
          "Standing Capacity",
          "RC Status",
          "RC Status as on",
          "RC tax upto",
          "unld wt",
          "Vehicle Category",
          "Vehicle Class",
          "Wheel base",
          "State",
          "Status",
          "Electric Vehicle",
          "Commercial Vehicle",
          "model_namev2",
          "make_id",
          "model_id",
          "variant_id",
          "make_name",
          "model_name",
          "variant_name",
          "suggested_make_id",
          "suggested_make_display_name",
          "suggested_model_id",
          "suggested_model_display_name",
          "suggested_variant_id",
          "suggested_variant_display_name",
          "Suggested Commercial Vehicle"
        ]
      });
      Apihelpers.get_rcprime_details_apihelper(API_DOC_BASE_URL + URL_RCPRIMEREVERSE, data).then(res => {
        if (res.data.statusCode == 200) {
          var vehicleName = res.data.vehicleName;
          var rc_number = res.data.rcNumber;
          var print = [];
          var i = 0;
          let result = res.data.data.map((dataOfelement, index) => {
            var Is_print = this.state.OnlyGetTheseDetailsOfApi.includes(dataOfelement.name);
            if (Is_print == true) {
              if ( dataOfelement.value == null ||dataOfelement.value.length <= 0) {
                dataOfelement.value = " - ";
              }
              print.push({ key: i + 2, name: dataOfelement.name, value: dataOfelement.value });
              i++;
            }
            return { key: index + 2, name: dataOfelement.name, value: dataOfelement.value }
          });
          $('.loader').css("display", "none");
          this.setState({
            rc_details: [{ key: 0, name: "Vehicle Name", value: vehicleName }, { key: 1, name: "RC Number", value: rc_number }].concat(print),
            is_data_found: true
          });
        }
        else {
          $('.loader').css("display", "none");
          this.setState({
            is_data_found: false,
            data_not_found: "Data Not Found"
          });
        }
      });
      //$('.loader').css("display", "none");
    }
    else {
        Alert.error("Please Enter Chassis Number");
        $('.loader').css("display", "none");
      }  
  }
  createAndDownloadPdf = () => {
    $('.loader').css("display", "block");
    let currentDateTime = Date.now();
    if (this.state.rc_details.length > 0 && this.state.Chassis_Number.length > 0 && this.state.is_data_found == true) {
      const data = {
        doc_details: this.state.rc_details,
        file_name: "RC_details_" + this.state.Chassis_Number + "_" + currentDateTime + ".pdf",
        type: 'rcPrimePdf'
      };
      Apihelpers.createAndDownloadPdf(createAndDownloadPdfForRcPrime, data).then(res => {
        console.log(res);
        if (res.status == 201) {
          var fileName = data.file_name;
          Apihelpers.downloadFileresponse("export-rcprime-reportpdf/" + fileName).then(res => {
            FileDownload(res.data, fileName);
            const detlete_file_path = { "filepath": "rc_prime_pdf_report/" + fileName };
            Apihelpers.postdataresponse(unlink_file, detlete_file_path);
          }).catch((err) => {
            console.log(err);
          });
          $('.loader').css("display", "none");
        } else {
          $('.loader').css("display", "none");
          Alert.error("Error While Generating Report");
        }
      });
      //$('.loader').css("display", "none");
    }
    else {
      $('.loader').css("display", "none");
      Alert.error("Data Not Found");
    }

  }
  On_chassis_number_input_change(input) {
    this.setState({
      Chassis_Number: input.toLocaleUpperCase(),
      is_data_found: false
    });
    if (this.state.Chassis_Number.length <= 0) {
      this.setState({
        data_not_found: ''
      });
    }
  }
  
  async Find_User_Have_Rc_Prime_Reverse_Pdf_Plan() {
    const bbuserid = reactLocalStorage.get("login_user_id")
    var startdate = "";
    var enddate = "";
    const ClientDetailsPostData = {
      startdate: "",
      enddate: ""
    };
    Apihelpers.postdataresponse(CLIENT_EDIT_VIEW + bbuserid, ClientDetailsPostData).then(async res => {
      if (res.data.status === true) { 
        this.setState({
          rc_prime_pdf_Authorization_Token: 'Bearer '+ res.data.data[0].bbuserInfo[0].token,
        });
        /*var bbPaymentHistory=res.data.data[0].bbuserpaymenthistoriesInfo
        let token=bbPaymentHistory.map((s) => {
          if (s.is_active == true) {
            this.setState({
              rc_prime_pdf_Authorization_Token: 'Bearer '+ s.token,
            });
            return s.token;
          }
        });*/
        this.setState({
          rc_prime_pdf_user_id: bbuserid,
          rc_prime_pdf_rto_user_id: res.data.data[0].bbuserInfo[0].userid
        });
        var parserActivePlan = JSON.parse(res.data.data[0].bbuserInfo[0].active_plan);
        if (parserActivePlan.service.length > 0) {
          parserActivePlan.service.map((dataOfelement, index) => {
            if (dataOfelement.isActive == 1 && dataOfelement.plantype === SERVICE21_TEXT) {
              this.setState({ bbuser_have_plan: true });
            }
          });
        }

      }
    });
  }
  render() {
    if (reactLocalStorage.get("login_type") === LOGIN_TYPE_ADMIN || reactLocalStorage.get("is_have_rcPrimeReversePdf_service") === SERVICE21_TEXT) {
      const is_data = this.state.is_data_found;
      return (
        <div className="wrapper">
          <Header />
          <div className="container">
            <div className="whiteBox variantPage">
              <div className="titleRow">
                <div className="row">
                  <div className="col">
                    <h3 className="title">Rc Prime Reverse </h3>
                  </div>
                  <div className="col">
                      <NavLink
                        to={this.state.urlForBackButton}
                        exact
                        style={{ float: "right", fontSize: "13px", color: "#1a73e8", textDecoration: "none" }}
                      >  <i className="fa fa-arrow-left"></i> Back</NavLink>
                    </div>
                </div>
              </div>
              <div className="mapFilterRow">
                <div className="row">
                  <div className="col-md-3">
                    <div className="form-group">
                      <label className="control-title">Enter Chassis Number </label>
                      <input className="form-control" tabIndex="1" id=""
                        value={this.state.Chassis_Number}
                        placeholder="Enter Chassis Number"
                        type="text"
                        onChange={(e) => this.On_chassis_number_input_change(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-md-1">
                    <div className="btnRow">
                      <button className="yellowBtn" type="button" tabIndex="3" onClick={this.get_reverse_prime_details}>Submit</button>
                    </div>
                  </div>
                  <div className="col-md-1">
                    <div className="btnRow">
                      <button className="yellowBtn" type="button" style={{ backgroundColor: "#1a73e8" }} tabIndex="4" onClick={this.createAndDownloadPdf}>Download</button>
                    </div>
                  </div>
                </div>
                <div className="varintInfoBlock" id="variantInfoId" style={{ display: "block" }}>
                  <div className="row">
                    {is_data ?
                      this.state.rc_details.map(dataElement => (
                        <>
                          <div className="col-md-6">
                            <div className="infoRow">
                              <div className="key" style={{ color: "#1a73e8", display: "inline" }}>{dataElement.name}  : </div>
                              <div className="val" style={{ display: "inline" }}>{dataElement.value}</div>
                            </div>
                          </div>
                        </>
                      ))
                      : <> <div className="col-md-12">
                        <div className="infoRow">
                          <div style={{ color: "#1a73e8", display: "inline", fontSize: "30px" }}>{this.state.data_not_found}</div>
                        </div>
                      </div></>}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="loader" style={{ display: "none" }}>
            <div className="bg"></div>
            <img className="loadingImg" src="/assets/images/loading.gif" alt="" />
          </div>
        </div>
      );
    }
    else {
      return (
        <UnAuthorised></UnAuthorised>
      )
    }
  }
}
export default rcprimereversepdf;
